import { createContext } from 'react';
import { IStatusBarWrapperContext } from './types';

export const StatusBarWrapperContext = createContext<IStatusBarWrapperContext>({
  statusBars: [],
});
